import { message } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import config from '../../../config';
import { getAsset } from '../../../services/general';
import { allowedFileCriteria, getBase64 } from "../../../utils/fileUtils";
import { useTranslation } from "react-i18next";
import countrySettings from '../countrySettings.json';

const useFingerprintPhoto = ({
  form,
  patientToAdmission,
  setPatientToAdmission,
  setLoading,
  countryCode,
}) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [visible, setVisible] = useState(false);
  const [fingerprintFile, setFingerprintFile] = useState();
  const { t } = useTranslation();

  const getFingerprint = useCallback(
    (fingerprintImage) => {
      setPatientToAdmission({
        ...patientToAdmission,
        fingerprint: fingerprintImage,
      });
      setFingerprintPhoto(fingerprintImage, true);
    },
    [setPatientToAdmission, patientToAdmission],
  );

  const listenerBrowser = useCallback(
    (url) => {
      window.addEventListener(
        'message',
        (event) => {
          if (url.startsWith(event.origin)) {
            if (event.data?.message?.fingerprint) {
              getFingerprint(event.data.message.fingerprint);
            }
          }
        },
        false,
      );
    },
    [getFingerprint],
  );

  const showFingerprintCapture = useCallback(() => {

    let url = `${config.validatorUrl}/fingerprint/admission`;
    let target = '_blank';
    let options = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1500,top=-1500`;

    listenerBrowser(url);
    window.open(url, target, options);
  }, [listenerBrowser]);

  const openModal = useCallback(() => {
    setVisible(true);

    if (countrySettings.fingerprintPhoto[countryCode]) {
      showFingerprintCapture();
    }
  }, [countryCode, showFingerprintCapture]);

  const closeModal = useCallback(() => {
    setVisible(false);
  }, [countryCode]);

  const setFingerprintPhoto = useCallback(
    (photo, isNew = true) => {
      setImageSrc(photo);
      if (form) {
        form.setFieldsValue({ fingerprint: { photo, isNew } });
      }
    },
    [form],
  );

  const fetchFingerprintPhoto = useCallback(
    async (params) => {
      try {
        setLoading((loading) => {
          return { ...loading, fingerprint: true };
        });
        const response = await getAsset({
          id: params.id,
          type: 'Patient',
          field: 'fingerprint',
        });
        setFingerprintPhoto(response.document_url, false);
      } catch (error) {
        console.error(error);
        message.error({
          content: 'No se pudo cargar la huella del paciente',
          style: {
            marginTop: '35vh',
            fontSize: 16,
          },
        });
        setFingerprintPhoto(null);
      } finally {
        setLoading((loading) => {
          return { ...loading, fingerprint: false };
        });
      }
    },
    [setLoading, setFingerprintPhoto],
  );

  const resetImage = useCallback(() => {
    setFingerprintPhoto(null);
    setFingerprintFile(undefined);
  }, [setFingerprintPhoto]);



  const beforeUpload = useCallback(async (file) => {
    const isAllowed = allowedFileCriteria(t, file, 2);
    if (isAllowed) {
      setFingerprintFile(file)
      const base64 = await getBase64(file)
      setFingerprintFile(base64, true, file.type)
    }
    return isAllowed;
  }, [setFingerprintFile, t])

  return {
    visible,
    openModal,
    closeModal,
    imageSrc,
    showFingerprintCapture,
    fetchFingerprintPhoto,
    resetImage,
    fingerprintFile,
    beforeUpload,
  };
};

export default useFingerprintPhoto;
